import * as notes from 'services/feature/notes'
import { createAction } from 'actions/utils'
import { apiAction, promiseApiAction } from '../application'

export const NOTES_RECEIVED = 'NOTES_RECEIVED'
export const getNotes = (id) =>
  apiAction({
    asyncFn: notes.get,
    args: { id },
    successActionType: NOTES_RECEIVED,
    id,
  })

export const NOTE_ADDED = 'NOTE_ADDED'
export const createNote = ({ id, note, subType, subUri, subDescription }) =>
  promiseApiAction({
    asyncFn: notes.create,
    args: { id, note, subType, subUri, subDescription },
    successActionType: NOTE_ADDED,
    id,
  })

export const DELETE_NOTES = 'DELETE_NOTES'
export const deleteNotes = createAction(DELETE_NOTES, ['noteIds'])

export const RESET_NOTES = 'RESET_NOTES'
export const resetNotes = createAction(RESET_NOTES)
